import React from 'react';
import { Alert, Typography } from '@mui/material';
import {
  evolutionInvalidationSummary,
  isEvolutionInvalidated,
  type EvolutionRecord,
} from '../../utils/evolutionRecordPolicy';

interface EvolutionInvalidationBannerProps {
  evolution?: EvolutionRecord | null;
  sx?: object;
}

const EvolutionInvalidationBanner: React.FC<EvolutionInvalidationBannerProps> = ({ evolution, sx }) => {
  if (!isEvolutionInvalidated(evolution)) return null;

  const summary = evolutionInvalidationSummary(evolution);
  const reason = String(evolution?.invalidation_reason || '').trim();

  return (
    <Alert severity="error" sx={{ mb: 2, ...sx }}>
      <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
        Evolução invalidada
      </Typography>
      {summary && (
        <Typography variant="caption" sx={{ display: 'block', mt: 0.25 }}>
          {summary}
        </Typography>
      )}
      {reason && (
        <Typography variant="body2" sx={{ mt: 0.75, whiteSpace: 'pre-wrap' }}>
          <strong>Justificativa:</strong> {reason}
        </Typography>
      )}
    </Alert>
  );
};

export default EvolutionInvalidationBanner;
